import { getFirstAvailableHub, getHubByKey, getHubByRoutingHub } from './hubs';

export const getMarketingSiteUrl = (hub, routingHub) => {
  const hubInfo = getHubByKey(hub) || getHubByRoutingHub(routingHub) || getFirstAvailableHub();

  return hubInfo.MARKETING_SITE_URI;
};
